import React from 'react';
import { AwardIcon, GraduationCapIcon, MedalIcon } from 'lucide-react';
import { recognition } from '../data/profile';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
const icons = [MedalIcon, AwardIcon, GraduationCapIcon];
export function Recognition() {
  return <section aria-label="Recognition and education" className="w-full border-t border-line bg-white py-20 lg:py-28" data-id="element-400" data-mp="1avs5fnupn3f1">
      <div className="mx-auto max-w-shell px-6 sm:px-8" data-id="element-401" data-mp="wuxsqt0mqgak">
        <Reveal data-id="element-402" data-mp="11w4zqpuy7bg6">
          <SectionLabel data-id="element-403" data-mp="11wn3s8nuqtyn">Recognition &amp; Education</SectionLabel>
          <h2 className="mt-6 max-w-2xl font-serif text-[32px] font-semibold leading-[1.12] tracking-[-0.015em] text-navy sm:text-4xl lg:text-[44px]" data-id="element-404" data-mp="mycowb0cjb8b">
            Credentialed by the profession, recognized by the industry
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-8 lg:grid-cols-3" data-id="element-405" data-mp="2hcvmq09y0qk0">
          {recognition.map((item, index) => {
          const Icon = icons[index] ?? MedalIcon;
          return <Reveal key={item.title} delay={index * 0.07} data-id="element-406" data-mp="1p2gksbj9weoi" data-mpi={index}>
                <article className="flex h-full flex-col border border-line bg-canvas p-8 transition-colors duration-200 ease-premium hover:border-metal/60" data-id="element-407" data-mp="1k56qahh11ctt">
                  <span className="flex h-11 w-11 items-center justify-center border border-metal" data-id="element-408" data-mp="1yvnprva3pso2">
                    <Icon className="h-5 w-5 text-metal" aria-hidden="true" data-id="element-409" data-mp="1twkvn5vnt6uv" />
                  </span>
                  <h3 className="mt-6 font-serif text-[22px] font-semibold leading-tight text-navy" data-id="element-410" data-mp="16701rrxywp6t">
                    {item.title}
                  </h3>
                  <p className="mt-2.5 text-[12px] font-medium uppercase tracking-[0.1em] text-charcoal-muted" data-id="element-411" data-mp="1f6n0u7385iwp">
                    {item.issuer} · {item.year}
                  </p>
                  <p className="mt-auto pt-6 text-[15px] leading-[1.7] text-charcoal-light" data-id="element-412" data-mp="2qk7lgky89qzc">
                    {item.detail}
                  </p>
                </article>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}